export default {
  'common.website.slogan': 'ChainIDE助力未来',
  'common.website.tagline': 'ChainIDE赋能未来，构建云端多链分布式世界'
};
